import { render, staticRenderFns } from "./DatosMedios.vue?vue&type=template&id=f21dfef8&scoped=true"
import script from "./DatosMedios.vue?vue&type=script&lang=js"
export * from "./DatosMedios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21dfef8",
  null
  
)

export default component.exports